import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Solution {
  id: string;
  creator_id: string;
  title: string;
  description?: string;
  agency: string;
  category: string;
  commercial_type: 'Sale' | 'Lease' | 'Collaborate' | 'Stake';
  base_price: number;
  price: number;
  status: 'draft' | 'published' | 'consumed';
  captured_date?: string;
  is_bounty: boolean;
  bounty_amount?: number;
  file_url?: string;
  file_name?: string;
  file_size?: number;
  file_type?: string;
  nft_cover_image_url?: string;
  created_at: string;
  updated_at: string;
  profiles?: {
    display_name: string;
    avatar_url?: string;
  };
  solution_network_members?: Array<{
    user_id: string;
    ownership_stake: number;
    gib_nifty?: string;
    profiles: {
      display_name: string;
      avatar_url?: string;
    };
  }>;
}

export const useSolutions = () => {
  return useQuery({
    queryKey: ['solutions'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('solutions')
        .select(`
          *,
          profiles:creator_id(display_name, avatar_url),
          solution_network_members(
            user_id,
            ownership_stake,
            gib_nifty,
            profiles:user_id(display_name, avatar_url)
          )
        `)
        .eq('status', 'published')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as Solution[];
    }
  });
};

export const useUserSolutions = (userId?: string) => {
  return useQuery({
    queryKey: ['solutions', userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from('solutions')
        .select(`
          *,
          solution_network_members(
            user_id,
            ownership_stake,
            gib_nifty,
            profiles:user_id(display_name, avatar_url)
          )
        `)
        .eq('creator_id', userId)
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as Solution[];
    },
    enabled: !!userId
  });
};
